<template>
  <WdsStack direction-column gap-custom="2.5rem" class="tw-mt-4">
    <Skeleton v-if="loading" />
    <template v-else>
      <BannerOverview v-if="timesheetFormStore.isViewOnly" />
      <WdsStack direction-column gap-lg>
        <ActiveWeekControl />
        <TimesheetTable />
      </WdsStack>
    </template>
  </WdsStack>
</template>

<script lang="ts" setup>
import { WdsStack } from '@worksome/wds-components'
import ActiveWeekControl from '@/components/Timesheet/ActiveWeekControl.vue'
import TimesheetTable from '@/components/Timesheet/TimesheetTable.vue'
import BannerOverview from '@/components/Timesheet/BannerOverview.vue'
import { useTimesheetFormStore } from '@/components/Timesheet/store/useTimesheetFormStore'
import Skeleton from '@/components/Timesheet/Skeleton.vue'
import { useTranslation } from '@/composables/translation'

defineProps<{
  loading: Boolean
}>()

const { $t } = useTranslation()
const timesheetFormStore = useTimesheetFormStore()
</script>

<style scoped lang="scss">
// Remove the bottom border on last row of table in order to display comment input area
:deep(tbody > tr:not(.table-empty):last-child > td) {
  border-bottom: none !important;
}

:deep(.timesheet-day-total) {
  &:not(:focus) {
    @apply tw-border-indigo-200;
    @apply tw-bg-indigo-50;
    @apply tw-text-indigo-500;
    &:hover {
      @apply tw-border-indigo-300;
    }
  }
}
</style>
